import { Info } from "lucide-react";

export default function Disclaimer({ variant = "inline" }) {
  const text =
    "InsureGenie provides educational information based on insurance documents and public sources. It is not an insurance company, broker, tax advisor, or financial advisor. Always consult a qualified professional before making financial decisions.";

  if (variant === "banner") {
    return (
      <div
        data-testid="disclaimer-banner"
        className="w-full bg-primary text-primary-foreground text-[12px] tracking-wide"
      >
        <div className="max-w-7xl mx-auto px-4 py-2 flex items-center gap-2 justify-center text-center">
          <Info className="w-3.5 h-3.5 opacity-80 flex-shrink-0" />
          <span className="opacity-90">Educational guidance only · Not financial advice · Consult a qualified professional</span>
        </div>
      </div>
    );
  }

  return (
    <div
      data-testid="disclaimer-inline"
      className="text-[12px] leading-relaxed text-muted-foreground border-t border-border pt-4 mt-4"
    >
      <span className="font-semibold text-foreground">Important disclaimer.</span> {text}
    </div>
  );
}
